import { ThemeOverrideTypes } from '.'

export const bauhausThemes: ThemeOverrideTypes[] = [
    'lifestyle',
    'entertainment',
    'sport',
    'tech',
    'politics',
    'business',
    'world',
    'best-picks',
]

/** Returns theme override for passed string which can be article topic ID or the current location. For components on page colors need (cards also) to be same and based on page location not on article topic
 *
 * @param topic string, current location or topic ID
 */
export function getBauhausThemeOverride(topic: string): ThemeOverrideTypes {
    if (topic.startsWith('/best-picks/travel')) {
        return 'best-picks'
    }

    if (topic.startsWith('/video/')) {
        return 'bauhaus-default'
    }
    //check for tms and sunrise\
    if (isEntertainmentTopic(topic)) {
        return 'entertainment'
    }

    //check for travel
    if (isLifestyleTopic(topic)) {
        return 'lifestyle'
    }

    const bauhausTheme = bauhausThemes.find(
        (route) => topic.startsWith(`/${route}`) || topic.startsWith(route),
    )

    if (bauhausTheme) {
        return bauhausTheme
    }

    return 'bauhaus-default'
}

export const isLifestyleTopic = (topic?: string): boolean => {
    if (
        topic &&
        (topic.includes('lifestyle') ||
            // need to remove lifestyle theme from /best-picks/travel
            (topic.includes('travel') && !topic.includes('best-picks')))
    ) {
        return true
    } else {
        return false
    }
}

export const isEntertainmentTopic = (topic?: string): boolean => {
    if (
        topic &&
        (topic.includes('entertainment') ||
            topic.includes('the-morning-show') ||
            topic.includes('sunrise') ||
            topic?.includes('spotlight'))
    ) {
        return true
    } else {
        return false
    }
}
